import { useMutation } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { useLocation } from 'react-router-dom';
import { CustomButton } from '../../../components/customButton/CustomButton.jsx';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico.jsx';
import { useGetConexionesDetalleRows } from '../hooks/useGetConexionesDetalleRows.js';
import { useGetConexionesDetalleColumns } from '../hooks/useGetConexionesColumns.js';
import { ConexionesDetalleHeader } from './ConexionesDetalleHeader.jsx';
import { CustomChip } from '../../../components/chip/Chip.jsx';
import moment from 'moment';
import { AUTORIZAR_CONEXIONES } from '../../../data/graphQL/mutations/AdminConexiones/autorizeConexiones.js';

import toast from 'react-hot-toast';

export const ConexionesDetalleContent = ({ setChildrenAction }) => {
  const location = useLocation();

  const UNCHECKEABLE_STATES = ['FF', 'PF', 'SU', 'BC', 'NC'];
  const ESTADO_AP_ID = 7;

  const {
    hc,
    nombrePaciente,
    documento,
    idDelegacion,
    idEvaluacion,
    month,
    year,
    fechaDesdeHasta,
    planDescripcion,
    contratoFechaDesde,
    contratoFechaHasta
  } = location?.state || {};

  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const {
    rows,
    totalCount,
    loading,
    setRows,
    handleSearch
  } = useGetConexionesDetalleRows(
    idEvaluacion,
    month,
    year
  );

  const [autorizeConexiones, { data: dataAutorizeConexiones, loading: autorizarLoading, error: errorAutorizeConexiones }] = useMutation(AUTORIZAR_CONEXIONES);

  useEffect(() => {
    if (!dataAutorizeConexiones) return;
    handleSearch();
    if (dataAutorizeConexiones?.autorizarConexiones.success) {
      toast.success('Conexiones autorizadas correctamente');
      setRowSelectionModel([]);
    }
  }, [dataAutorizeConexiones]);

  useEffect(() => {
    if (!errorAutorizeConexiones) return;
    toast.error('Error al autorizar conexiones');
  }, [errorAutorizeConexiones]);

  const getChipEstado = (estado) => {
    if (!estado) return <CustomChip label={'-'} />;
    switch (estado?.toUpperCase()) {
      case 'AP':
        return <CustomChip isRed label={estado} />;
      case 'PE':
        return <CustomChip isYellow label={estado} />;
      case 'AT':
        return <CustomChip isGreen label={estado} />;
      default:
        return <CustomChip label={estado} />;
    }
  };
  const columns = useGetConexionesDetalleColumns(getChipEstado);

  const gridLoading = useMemo(() => loading, [loading]);

  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        <CustomButton
          className='button-header'
          disabled={!rowSelectionModel?.length || loading}
          isLoading={autorizarLoading}
          label='Autorizar conexiones'
          onClick={onAutorize}
          variant='contained' />

      </div>
    );
  }, [setChildrenAction, loading, autorizarLoading, rowSelectionModel]);

  useEffect(() => {
    if (!loading && rows.length > 0) {
      const selectableIds = rows.
        filter((row) => isRowSelectable({ row })).
        map((row) => row.numeroDia);
      setRowSelectionModel(selectableIds);
    }
  }, [loading, rows]);

  const onSelectConexion = (ids) => {
    setRowSelectionModel(ids);
  };

  const onAutorize = () => {
    const selectedContratos = rows.
      map((row, index) => {
        const {
          idConexion,
          idEvaluacion,
          estadoAbreviacion,
          idEstado,
          idIndicacion,
          fecha
        } = row;

        return {
          idConexion,
          checked: rowSelectionModel.includes(index + 1),
          idEvaluacion,
          idEstado: estadoAbreviacion.toUpperCase() === 'AP' ? ESTADO_AP_ID : idEstado,
          idIndicacion,
          fechaConexion: fecha
        };
      }).
      filter((row) => isRowSelectable({ row }));

    autorizeConexiones({
      variables: { conexiones: selectedContratos }
    });
  };


  const isRowSelectable = (params) => {
    const { row } = params;
    if (UNCHECKEABLE_STATES.includes(row?.estadoAbreviacion)) return false;

    const rowDate = moment(row.fecha);
    const today = moment();

    // Verificar si la fila es de un mes anterior al mes pasado (siempre no seleccionable)
    const twoMonthsAgo = moment().subtract(2, 'months');
    if (
      rowDate.year() < twoMonthsAgo.year() ||
      rowDate.year() === twoMonthsAgo.year() && rowDate.month() <= twoMonthsAgo.month()) {
      return false;
    }

    // Verificar si es del mes pasado y estamos después del día 10
    const lastMonth = moment().subtract(1, 'month');
    if (
      today.date() > 10 &&
      rowDate.month() === lastMonth.month() &&
      rowDate.year() === lastMonth.year()) {
      return false;
    }

    // Si pasó todas las validaciones, es seleccionable
    return true;
  };

  return (
    <div>
      <ConexionesDetalleHeader
        hc={hc}
        paciente={nombrePaciente}
        fechaDesdeHasta={fechaDesdeHasta}
        contrato={idEvaluacion}
        documento={documento}
        planDescripcion={planDescripcion}
        contratoFechaDesde={contratoFechaDesde}
        contratoFechaHasta={contratoFechaHasta}
        getChipEstado={getChipEstado} />

      <DataGridGenerico
        checkboxSelection
        disabledSelectionAll
        onRowSelectionModelChange={onSelectConexion}
        rowSelectionModel={rowSelectionModel}
        columns={columns}
        autoMaxWidth
        totalCount={totalCount}
        rows={rows}
        toolbar={false}
        loading={gridLoading}
        isRowSelectable={isRowSelectable} />

    </div>);

};